import Vue from 'vue'
import Router from 'vue-router'
import API from '@/API.js'
import Axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          redirect: '/tracking'
        },
        {
          path: '/home',
          name: 'home',
          component: () => import('./views/DashboardUser.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // Setting Routes
        // =============================================================================
        {
          path: '/menu',
          name: 'menu',
          component: () => import('./views/setting/Menu.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Setting Menu'
          }
        },
        {
          path: '/command-assignment',
          name: 'command-assignment',
          component: () => import('./views/setting/CommandAssignment.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Command Assignment'
          }
        },
        {
          path: '/imei-assignment',
          name: 'imei-assignment',
          component: () => import('./views/setting/ImeiAssignment.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Imei Assignment'
          }
        },
        {
          path: '/permission',
          name: 'permission',
          component: () => import('./views/setting/Permission.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Setting Permission'
          }
        },

        {
          path: '/dashboard-chart-assignment',
          name: 'dashboard-chart-assignment',
          component: () =>
            import('./views/setting/DashboardChartAssignment.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Dashboard Chart Assignment'
          }
        },

        // =============================================================================
        // Data Master Routes
        // =============================================================================
        {
          path: '/vehicle-brand',
          name: 'vehicle-brand',
          component: () => import('./views/master/VehicleBrand.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle Brand'
          }
        },
        {
          path: '/vehicle-type',
          name: 'vehicle-type',
          component: () => import('./views/master/VehicleType.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle Type'
          }
        },
        {
          path: '/vehicle-list',
          name: 'vehicle-list',
          component: () => import('./views/master/VehicleList.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle List'
          }
        },
        {
          path: '/vehicle-icon',
          name: 'vehicle-icon',
          component: () => import('./views/master/VehicleIcon.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle Icon'
          }
        },
        {
          path: '/gps-type',
          name: 'gps-type',
          component: () => import('./views/master/GpsType.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'GPS Type'
          }
        },
        {
          path: '/ref-alert',
          name: 'ref-alert',
          component: () => import('./views/master/RefAlert.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Ref Alert'
          }
        },
        {
          path: '/poi-icon',
          name: 'poi-icon',
          component: () => import('./views/master/PoiIcon.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'POI Icon'
          }
        },
        {
          path: '/imei',
          name: 'imei',
          component: () => import('./views/master/Imei.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Master Imei'
          }
        },
        // {
        //   path: '/gsm',
        //   name: 'gsm',
        //   component: () => import('./views/Gsm.vue'),
        //   meta: {
        //     rule: 'editor',
        //     pageTitle: 'Master GSM'
        //   }
        // },
        // {
        //   path: '/gsm-type',
        //   name: 'gsm-type',
        //   component: () => import('./views/GsmType.vue'),
        //   meta: {
        //     rule: 'editor',
        //     pageTitle: 'Gsm Type'
        //   }
        // },
        {
          path: '/command',
          name: 'command',
          component: () => import('./views/master/Command.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Master Command'
          }
        },

        {
          path: '/dashboard-chart',
          name: 'dashboard-chart',
          component: () => import('./views/master/DashboardChart.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Dashboard Chart'
          }
        },

        // {
        //   path: '/item-code',
        //   name: 'item-code',
        //   component: () => import('./views/ItemCode.vue'),
        //   meta: {
        //     rule: 'editor',
        //     pageTitle: 'Item Code'
        //   }
        // },
        // =============================================================================
        // Management Routes
        // =============================================================================
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/Users.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'User Management'
          }
        },
        {
          path: '/vehicle',
          name: 'vehicle',
          component: () => import('./views/Vehicle.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle Management'
          }
        },
        {
          path: '/email-notification',
          name: 'email-notification',
          component: () => import('./views/EmailNotification.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Email Notification'
          }
        },
        {
          path: '/poi',
          name: 'poi',
          component: () => import('./views/Poi.vue'),
          meta: {
            rule: 'editor'
            // pageTitle: 'POI Management'
          }
        },
        {
          path: '/geofence',
          name: 'geofence',
          component: () => import('./views/Geofence.vue'),
          meta: {
            rule: 'editor'
            // pageTitle: 'Geofence Management'
          }
        },
        {
          path: '/shared-location',
          name: 'shared-location',
          component: () => import('./views/SharedLocation.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Shared Location'
          }
        },
        {
          path: '/warranty-check',
          name: 'warranty-check',
          component: () => import('./views/WarrantyCheck.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Warranty Check'
          }
        },
        {
          path: '/telegram-notification',
          name: 'telegram-notification',
          component: () => import('./views/TelegramNotification.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Telegram Notification'
          }
        },
        {
          path: '/service-due-date',
          name: 'service-due-date',
          component: () => import('./views/ServiceDueDate.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Service Due Date'
          }
        },
        {
          path: '/technician',
          name: 'technician',
          component: () => import('./views/Technician.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Technician'
          }
        },
        {
          path: '/sales',
          name: 'sales',
          component: () => import('./views/management/Sales.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Sales'
          }
        },
        {
          path: '/speed-limit-by-zone',
          name: 'speed-limit-by-zone',
          component: () => import('./views/SpeedLimitByZone.vue'),
          meta: {
            rule: 'editor'
            // pageTitle: 'POI Management'
          }
        },
        {
          path: '/alert-score',
          name: 'alert-score',
          component: () => import('./views/management/AlertScoring.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Alert Score'
          }
        },
        {
          path: '/driving-score',
          name: 'driving-score',
          component: () => import('./views/management/DrivingScoring.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Driving Score'
          }
        },
        {
          path: '/dealer-status',
          name: 'dealer-status',
          component: () => import('./views/management/DealerStatus.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Dealer Status'
          }
        },
        {
          path: '/min-max-temperature',
          name: 'min-max-temperature',
          component: () => import('./views/management/MinMaxTemperature.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Min Max Temperature'
          }
        },
        {
          path: '/share-vehicle',
          name: 'share-vehicle',
          component: () => import('./views/management/ShareVehicle.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Share Vehicle'
          }
        },
        {
          path: '/users-notif',
          name: 'users-notif',
          component: () => import('./views/management/UsersNotif.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Users Notification'
          }
        },
        {
          path: '/transfer-unit',
          name: 'transfer-unit',
          component: () => import('./views/management/TransferUnit.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Transfer Unit'
          }
        },
        {
          path: '/user-special-range',
          name: 'transfer-unit',
          component: () => import('./views/management/UsersSpecialRange.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'User Special Range'
          }
        },
        // =============================================================================
        // Tracking Routes
        // =============================================================================
        {
          path: '/tracking',
          name: 'tracking',
          component: () => import('./views/Tracking2.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/tracking2',
          name: 'tracking2',
          component: () => import('./views/Tracking2.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/track-replay/:imei',
          name: 'track-replay',
          component: () => import('./views/TrackReplay.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/tracking-v2',
          name: 'tracking-v2',
          component: () => import('./views/TrackingV2.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // History
        // =============================================================================
        {
          path: '/alert',
          name: 'alert',
          component: () => import('./views/history/Alert.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'History Alert'
          }
        },
        {
          path: '/poi-log',
          name: 'poi-log',
          component: () => import('./views/POILog.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'POI Log'
          }
        },
        {
          path: '/poi-summary',
          name: 'poi-summary',
          component: () => import('./views/report/PoiSummaryReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'POI Summary'
          }
        },
        {
          path: '/vehicle-on-poi',
          name: 'vehicle-on-poi',
          component: () => import('./views/report/VehicleOnPoiReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Vehicle On POI'
          }
        },
        {
          path: '/unreported-vehicle',
          name: 'unreported-vehicle',
          component: () => import('./views/UnreportedVehicle.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Unreported Vehicle'
          }
        },
        {
          path: '/change-plate',
          name: 'change-plate',
          component: () => import('./views/ChangePlate.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Change Plate'
          }
        },
        {
          path: '/change-gsm-no',
          name: 'change-gsm-no',
          component: () => import('./views/ChangeGsm.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Change GSM No'
          }
        },
        {
          path: '/command-history',
          name: 'command-history',
          component: () => import('./views/CommandHistory.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Command'
          }
        },
        {
          path: '/import-imei',
          name: 'import-imei',
          component: () => import('./views/ImportImei.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'History Import Imei'
          }
        },
        {
          path: '/service-history',
          name: 'service-history',
          component: () => import('./views/ServiceHistory.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'History Service'
          }
        },
        {
          path: '/change-unit',
          name: 'change-unit',
          component: () => import('./views/ChangeUnit.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'History Change Unit'
          }
        },
        // =============================================================================
        // Profile
        // =============================================================================
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/Profile.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Profile'
          }
        },
        // =============================================================================
        // REPORT
        // =============================================================================
        {
          path: '/historical-data-report',
          name: 'historical-data-report',
          component: () => import('./views/report/HistoricalDataReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Historical Data Report'
          }
        },
        {
          path: '/data-by-speed',
          name: 'data-by-speed',
          component: () => import('./views/report/DataBySpeed.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Data By Speed'
          }
        },
        {
          path: '/stop-report',
          name: 'stop-report',
          component: () => import('./views/report/StopReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Stop Report'
          }
        },
        {
          path: '/parking-report',
          name: 'parking-report',
          component: () => import('./views/report/ParkingReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Parking Report'
          }
        },
        {
          path: '/running-report',
          name: 'running-report',
          component: () => import('./views/report/RunningReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Running Report'
          }
        },
        {
          path: '/hourmeter',
          name: 'hourmeter',
          component: () => import('./views/report/HourmeterReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Hourmeter Report'
          }
        },
        {
          path: '/door-report',
          name: 'door-report',
          component: () => import('./views/report/DoorReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Door Report'
          }
        },
        {
          path: '/daily-report',
          name: 'daily-report',
          component: () => import('./views/report/DailyReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Daily Report'
          }
        },
        {
          path: '/mileage-report',
          name: 'mileage-report',
          component: () => import('./views/report/MileageReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Mileage Report'
          }
        },
        {
          path: '/speed-chart',
          name: 'speed-chart',
          component: () => import('./views/report/SpeedChart.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Speed Chart'
          }
        },
        {
          path: '/fuel-chart',
          name: 'fuel-chart',
          component: () => import('./views/report/FuelChart.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Fuel Chart'
          }
        },
        {
          path: '/temperature-chart',
          name: 'temperature-chart',
          component: () => import('./views/report/TemperatureChart.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Temperature Chart'
          }
        },
        {
          path: '/deleted-vehicle',
          name: 'deleted-vehicle',
          component: () => import('./views/report/DeletedVehicle.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Deleted Vehicle'
          }
        },
        {
          path: '/driving-behavior',
          name: 'driving-behavior',
          component: () => import('./views/report/DrivingBehavior.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Driving Behavior'
          }
        },
        {
          path: '/driving-behavior-chart',
          name: 'driving-behavior-chart',
          component: () => import('./views/report/DrivingBehaviorChart.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Driving Behavior Chart'
          }
        },
        {
          path: '/test-drive',
          name: 'test-drive',
          component: () => import('./views/report/TestDriveReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Test Drive Report'
          }
        },
        {
          path: '/duration-overspeed',
          name: 'duration-overspeed',
          component: () => import('./views/report/DurationOverSpeedReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Overspeed Duration Report'
          }
        },

        {
          path: '/summary-report',
          name: 'summary-report',
          component: () => import('./views/report/SummaryReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Summary Report'
          }
        },

        {
          path: '/map-summary',
          name: 'map-summary',
          component: () => import('./views/report/MapSummary.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Map Journey'
          }
        },

        {
          path: '/trip-report',
          name: 'trip-report',
          component: () => import('./views/report/TripReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Trip Report'
          }
        },

        {
          path: '/map-trip',
          name: 'map-trip',
          component: () => import('./views/report/MapTrip.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Map Trip'
          }
        },

        {
          path: '/ritase-report',
          name: 'ritase-report',
          component: () => import('./views/report/RitaseReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Ritase Report'
          }
        },

        {
          path: '/map-ritase',
          name: 'map-ritase',
          component: () => import('./views/report/MapRitase.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Map Ritase'
          }
        },

        {
          path: '/daily-report-all',
          name: 'daily-report-all',
          component: () => import('./views/report/DailyReportAll.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Daily Report All'
          }
        },
        {
          path: '/parking-report-all',
          name: 'parking-report-all',
          component: () => import('./views/report/ParkingReportAll.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Parking Report All'
          }
        },
        {
          path: '/summary-alarm-report',
          name: 'summary-alarm-report',
          component: () => import('./views/report/SummaryAlarmReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Summary Alarm Report'
          }
        },
        {
          path: '/driving-behavior2',
          name: 'driving-behavior2',
          component: () => import('./views/report/DrivingBehavior2.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Driving Behavior Report (Reduce)'
          }
        },
        {
          path: '/time-visit',
          name: 'time-visit',
          component: () => import('./views/report/TimeVisitReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Time Visit Report'
          }
        },
        {
          path: '/top-ten-mileage-driver',
          name: 'top-ten-mileage-driver',
          component: () =>
            import('./views/report/TopTenMIleageDriverReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Top Ten Mileage of Driver Report'
          }
        },
        {
          path: '/top-ten-overspeed-driver',
          name: 'top-ten-overspeed-driver',
          component: () =>
            import('./views/report/TopTenOverSpeedDriverReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Top Ten Overspeed of Driver Report'
          }
        },

        // =============================================================================
        // JOB ORDER
        // =============================================================================
        {
          path: '/job-order/driver',
          name: 'job-order/driver',
          component: () => import('./views/jobOrder/Driver.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Master Driver'
          }
        },
        {
          path: '/job-order/customer',
          name: 'job-order/customer',
          component: () => import('./views/jobOrder/Customer.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Master Customer'
          }
        },
        {
          path: '/job-order/routes',
          name: 'job-order/routes',
          component: () => import('./views/jobOrder/Route.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/job-order/order',
          name: 'job-order/order',
          component: () => import('./views/jobOrder/Order.vue'),
          meta: {
            rule: 'editor'
          }
        },

        // =============================================================================
        // Data Integration
        // =============================================================================
        {
          path: '/project-master',
          name: 'project-master',
          component: () => import('./views/integration/ProjectMaster.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Project Master'
          }
        },
        {
          path: '/project-assignment',
          name: 'project-assignment',
          component: () => import('./views/integration/ProjectAssignment.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Project Assignment'
          }
        },

        // =============================================================================
        // Dashcam Routes
        // =============================================================================
        {
          path: '/dashcam/live-tracking',
          name: 'dashcam/live-tracking',
          component: () => import('./views/dashcam/LiveTracking.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Dashcam'
          }
        },
        {
          path: '/dashcam/history',
          name: 'dashcam/history',
          component: () => import('./views/dashcam/History.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Dashcam History'
          }
        },
        {
          path: '/dashcam/log-streaming',
          name: 'dashcam/log-streaming',
          component: () => import('./views/dashcam/LogStreaming.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Log Streaming'
          }
        },
        // =============================================================================
        // Inbox
        // =============================================================================
        {
          path: '/inbox',
          name: 'inbox',
          component: () => import('./views/Inbox.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Inbox'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          // component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/email_subscription/verify/:key',
          name: 'email_subscription',
          component: () => import('@/views/pages/EmailVerification.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Email Verification'
          }
        },

        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/recover_password/:key',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/account_verification/:code',
          name: 'account_verification',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Account Verification'
          }
        }
      ]
    },

    {
      path: '/login/:token',
      name: 'login',
      component: () => import('./views/PortalLogin.vue'),
      meta: {
        rule: 'editor'
      }
    },

    /* SHARED LOCATION */
    {
      path: '/share/:key/:imei',
      name: 'share_location',
      component: () => import('@/views/pages/ShareLocation.vue'),
      meta: {
        rule: 'editor'
      }
    },

    // MONITORING

    {
      path: '/monitoring',
      name: 'monitoring',
      component: () => import('@/views/pages/Monitoring.vue'),
      meta: {
        rule: 'editor'
      }
    },

    // PLAYBACK
    {
      path: '/playback/:imei',
      name: 'playback',
      component: () => import('@/views/pages/Playback.vue'),
      meta: {
        rule: 'editor'
      }
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (to.name === 'page-login') window.location.href = API.portal_url
  if (
    [
      'login',
      'page-register',
      'page-forgot-password',
      'page-reset-password',
      'account_verification',
      'share_location',
      'email_subscription'
    ].indexOf(to.name) != -1
  ) {
    // if(localStorage.getItem('userInfo') != null && to.name != 'login'){
    //   router.push({ path: '/tracking' })
    // }
  } else {
    if (localStorage.getItem('userInfo') == null) {
      // router.push({ path: '/login' })
      // router.go('http://localhost:8081')
      window.location.href = API.portal_url
    } else {
      let token =
        typeof localStorage.getItem('userInfo') !== undefined
          ? JSON.parse(localStorage.getItem('userInfo')).token
          : ''
      Axios.get(`${API.endpoint}/menu/permission`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((res) => {
        var data = res.data.message.data
        // console.log(Object.values(data))
        // console.log(to.name)
        // console.log(Object.values(data).indexOf(to.name))
        // console.log(['page-error-404'].indexOf(to.name))
        if (
          Object.values(data).indexOf(to.name) == -1 &&
          [
            'page-error-404',
            'profile',
            'track-replay',
            'dashcam-history',
            'map-summary',
            'map-trip',
            'monitoring',
            'playback',
            'map-journey',
            'map-ritase',
            'inbox'
          ].indexOf(to.name) == -1
        )
          router.push({ path: '/error-404' })
      })
    }
  }

  return next()
})

export default router
